module.exports = __webpack_public_path__ + "img/medoro-light.012cd546.svg";